<script setup lang="ts">
import {
  BasketballFourPointShotMadeAttribute,
  BasketballFourPointShotMissedAttribute,
  BasketballIncidentId,
  Participant,
} from '@collector/sportsapi-client-legacy'
import { useBasketballSeasonDetails } from '@desktop/views/Relation/Sports/Basketball/composables'
import PitchIncidentButton from '@desktop/views/Relation/Sports/components/RelationView/Main/PitchWithIncidents/PitchIncidentButton/PitchIncidentButton.vue'
import PitchBlockedIncidentOverlay from '@desktop/views/Relation/Sports/components/RelationView/Main/PitchWithIncidents/PitchIncidents/PitchParticipantWithIncidents/PitchBlockedIncidentOverlay.vue'

import FoulBonusButton from './FoulBonusButton.vue'
import FoulCounter from './FoulCounter.vue'

interface Props {
  participant: Participant
  reversed?: boolean
}

defineProps<Props>()

// composables
const { isFourPointsShotEnabled } = useBasketballSeasonDetails()
</script>

<template>
  <div class="relative flex-1">
    <PitchBlockedIncidentOverlay />
    <div
      class="gap-y-fluid grid grid-cols-2 items-end justify-end gap-x-2"
      :dir="reversed ? 'rtl' : undefined"
    >
      <FoulCounter
        :participant
        :reversed
      />

      <FoulBonusButton :participant />

      <PitchIncidentButton
        v-if="isFourPointsShotEnabled"
        :participant
        :name="`4pt\n+`"
        :incidentId="BasketballIncidentId.FourPointShotMade"
        :attributeId="BasketballFourPointShotMadeAttribute.JumpShot"
      />

      <PitchIncidentButton
        v-if="isFourPointsShotEnabled"
        :participant
        :name="`4\nMISS`"
        :incidentId="BasketballIncidentId.FourPointShotMissed"
        :attributeId="BasketballFourPointShotMissedAttribute.JumpShot"
      />
    </div>
  </div>
</template>
